import React, { useEffect, useState } from "react";
import apiClient, { authedFileUrl } from "@/api/client";
import { FileText, Download } from "lucide-react";

export default function PortalFiles() {
  const [files, setFiles] = useState([]);
  useEffect(() => { apiClient.get("/portal/overview").then(r => setFiles(r.data.files)); }, []);
  return (
    <div className="space-y-5" data-testid="portal-files">
      <div><h1 className="text-2xl font-bold">Dosyalar & Raporlar</h1><p className="text-sm text-[#64748B] mt-1">{files.length} dosya</p></div>
      {files.length === 0 ? (
        <div className="ky-card p-16 text-center text-[#94A3B8]"><FileText size={32} className="mx-auto mb-2"/>Henüz dosya paylaşılmadı.</div>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
          {files.map(f => (
            <a key={f.id} href={authedFileUrl(f.id)} target="_blank" rel="noreferrer" className="ky-card p-4 flex items-start gap-3 ky-card-hover">
              <div className="w-10 h-10 rounded-lg bg-[#EEF2FF] text-[#4F46E5] flex items-center justify-center"><FileText size={16}/></div>
              <div className="flex-1 min-w-0"><div className="text-sm font-medium truncate">{f.original_filename}</div><div className="text-[11px] text-[#94A3B8] mt-0.5">{(f.size/1024).toFixed(1)} KB · {new Date(f.created_at).toLocaleDateString("tr-TR")}</div></div>
              <Download size={14} className="text-[#94A3B8] mt-1"/>
            </a>
          ))}
        </div>
      )}
    </div>
  );
}
